module.exports = __webpack_public_path__ + "img/logo_manpro.d8cb5338.svg";